export const numberToWords = (value: number): string => {
    if (value === 0) return 'zero reais';

    const units = ['', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove'];
    const teens = ['dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove'];
    const tens = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa'];
    const hundreds = ['', 'cento', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos', 'seiscentos', 'setecentos', 'oitocentos', 'novecentos'];

    const formatGroup = (n: number): string => {
        if (n === 0) return '';
        if (n === 100) return 'cem';

        let str = '';
        const h = Math.floor(n / 100);
        const t = Math.floor((n % 100) / 10);
        const u = n % 10;

        if (h > 0) {
            str += hundreds[h];
            if (n % 100 !== 0) str += ' e ';
        }

        if (t > 1) {
            str += tens[t];
            if (u > 0) str += ' e ' + units[u];
        } else if (t === 1) {
            str += teens[u];
        } else if (u > 0) {
            str += units[u];
        }

        return str;
    };

    const integerPart = Math.floor(value);
    const decimalPart = Math.round((value - integerPart) * 100);

    let result = '';

    // Millions
    const millions = Math.floor(integerPart / 1000000);
    if (millions > 0) {
        result += formatGroup(millions) + (millions === 1 ? ' milhão' : ' milhões');
        if (integerPart % 1000000 !== 0) result += ' e ';
    }

    // Thousands
    const thousands = Math.floor((integerPart % 1000000) / 1000);
    if (thousands > 0) {
        if (thousands === 1 && millions === 0) {
            // Do nothing for "um mil" usually just "mil" in PT-BR context if at start? 
            // Actually standard is 'mil', but 'um mil' is valid for currency checks.
            // Let's stick to 'mil' if it's cleaner, but 'um mil' avoids ambiguity.
            result += 'um mil';
        } else {
            result += formatGroup(thousands) + ' mil';
        }
        if (integerPart % 1000 !== 0) {
            // Rules for 'e':
            // If remaining is < 100 or multiple of 100
            const rem = integerPart % 1000;
            if (rem < 100 || rem % 100 === 0) result += ' e ';
            else result += ', ';
        }
    }

    // Units
    const remainingUnits = integerPart % 1000;
    if (remainingUnits > 0) {
        result += formatGroup(remainingUnits);
    }

    if (integerPart > 0) {
        result += integerPart === 1 ? ' real' : ' reais';
    }

    if (decimalPart > 0) {
        if (integerPart > 0) result += ' e ';
        result += formatGroup(decimalPart) + (decimalPart === 1 ? ' centavo' : ' centavos');
    }

    return result.trim();
};
